import Cookies from "cookies-js";
import {
  CONFIG_LOADED,
  HTTP_BUSY,
  HTTP_SUCCESS,
  HTTP_FAILURE,
  LANGUAGE_LOADED,
} from "./actions";

const reducer = (state = {}, action) => {
  switch (action.type) {
    case CONFIG_LOADED:
      return {
        ...state,
        config: action.config,
      };
    case HTTP_BUSY:
      return {
        ...state,
        busy: true,
        error: false,
        message: "",
        url: null,
      };
    case HTTP_SUCCESS:
      return {
        ...state,
        busy: false,
        error: false,
        message: "",
        status: action.status,
        success: action.success,
        url: action.url,
      };
    case HTTP_FAILURE:
      return {
        ...state,
        busy: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export const languageReducer = (state = {}, action) => {
  switch (action.type) {
    case LANGUAGE_LOADED:
      return action.payload;
    default:
      return state;
  }
};

export const SHOP_CULTURE = "shop-culture";
export const BOOKING_CULTURE = "booking-culture";
export const CULTURE = "members_culture";
export const THEME = "theme";

const keys = [CULTURE, THEME];

export const cookiesReducer = (config) => (state, action) => {
  state = state || getInitialState(keys, config);
  // console.log(getInitialState(keys));
  switch (action.type) {
    case "@EE/EXPIRE_COOKIE": {
      const c = {};
      c[action.key] = null;

      return Object.assign({}, state, c);
    }
    case "@EE/SET_COOKIE": {
      const c = {};
      c[action.key] = action.value;

      return Object.assign({}, state, c);
    }
    default:
      return state;
  }
};

const InitialState = {
  theme: "light",
  culture: "sv-SE",
};

function getInitialState(keys, config) {
  const state = {};
  const bookingCulture = () => Cookies.get(BOOKING_CULTURE);
  const shopCulture = () => Cookies.get(SHOP_CULTURE);
  const culture = () => Cookies.get(CULTURE);
  const noCultureCookie = !bookingCulture() && !shopCulture() && !culture();

  //Check if culture and theme is in cookie

  if (noCultureCookie) {
    Cookies.set(CULTURE, InitialState.culture);
  }
  if (bookingCulture()) {
    Cookies.set(CULTURE, bookingCulture());
  }

  if (shopCulture()) {
    Cookies.set(CULTURE, shopCulture());
  }

  if (culture()) {
    Cookies.set(CULTURE, culture());
  }

  // if (Cookies.get(THEME) == null) {
  //   const defaultTheme = config.theme || InitialState.theme;
  //   Cookies.set(THEME, defaultTheme);
  // }

  Cookies.set(THEME, "light");

  for (var i = 0; i < keys.length; i++) {
    const key = keys[i];
    state[key] = Cookies.get(key);
  }
  return state;
}

export default reducer;
